<div class="contenedor-dialog">

  <ngx-spinner [zIndex]="100" name="spExportacionBanco" bdColor="rgba(255,255,255,0.8)" size="default"
    color="#009688" type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <h2 mat-dialog-title class="titulo-dialog">
    <mat-icon>account_balance</mat-icon>
    Exportar archivo al banco
  </h2>

  <mat-dialog-content>

    <!-- Bloqueantes: si hay alguno, no se puede generar el archivo -->
    <div class="aviso bloqueante" *ngIf="validacion.bloqueantes.length > 0">
      <div class="aviso-titulo">
        <mat-icon>block</mat-icon>
        No se puede generar el archivo
      </div>
      <ul>
        <li *ngFor="let b of validacion.bloqueantes; trackBy: trackByItems">{{ b }}</li>
      </ul>
    </div>

    <!-- Advertencias: el archivo sale, pero con menos de lo tildado -->
    <div class="aviso advertencia" *ngIf="validacion.advertencias.length > 0">
      <div class="aviso-titulo">
        <mat-icon>warning</mat-icon>
        Revisá antes de exportar
      </div>
      <ul>
        <li *ngFor="let a of validacion.advertencias; trackBy: trackByItems">{{ a }}</li>
      </ul>
    </div>

    <ng-container *ngIf="!cargando">

      <!-- Destino -->
      <h3 class="titulo-seccion">
        <mat-icon>account_balance</mat-icon> Banco destino
      </h3>

      <div class="grilla-datos">
        <div class="dato">
          <span class="etiqueta">Banco</span>
          <span class="valor">{{ validacion.nombreBanco || '—' }}</span>
        </div>
        <div class="dato">
          <span class="etiqueta">Formato</span>
          <span class="valor">{{ validacion.nombreTemplate || '—' }}</span>
        </div>
        <div class="dato">
          <span class="etiqueta">Archivo</span>
          <span class="valor">{{ validacion.nombreArchivo || '—' }}</span>
        </div>
      </div>

      <!-- Origen -->
      <h3 class="titulo-seccion">
        <mat-icon>savings</mat-icon> Cuenta de origen
      </h3>

      <div class="grilla-datos">
        <div class="dato">
          <span class="etiqueta">Cuenta</span>
          <span class="valor">{{ validacion.cuentaOrigen || '—' }}</span>
        </div>
        <div class="dato">
          <span class="etiqueta">CBU</span>
          <span class="valor">{{ cbuParcial(validacion.cbuOrigen) || '—' }}</span>
        </div>
      </div>

      <!-- Resumen -->
      <h3 class="titulo-seccion">
        <mat-icon>summarize</mat-icon> Resumen
      </h3>

      <div class="resumen">
        <span class="dato-resumen">
          <mat-icon>swap_horiz</mat-icon>
          <b>{{ validacion.cantidadTransferencias }}</b> transferencias
        </span>
        <span class="dato-resumen">
          <mat-icon>receipt_long</mat-icon>
          <b>{{ validacion.cantidadLiquidaciones }}</b> liquidaciones
        </span>
        <span class="dato-resumen total">
          <mat-icon>payments</mat-icon>
          Total: <b>{{ validacion.totalAExportar | currency }}</b>
        </span>
      </div>

      <!-- Lo que va -->
      <h3 class="titulo-seccion">
        <mat-icon>check_circle</mat-icon> Se incluyen en el archivo
      </h3>

      <div class="tabla-container" *ngIf="dataSourceTransferencias.data.length > 0">
        <table mat-table [dataSource]="dataSourceTransferencias" class="tabla-dialog">

          <ng-container matColumnDef="propietario">
            <th mat-header-cell *matHeaderCellDef>Propietario</th>
            <td mat-cell *matCellDef="let t"><b>{{ t.propietario }}</b></td>
          </ng-container>

          <ng-container matColumnDef="cbu">
            <th mat-header-cell *matHeaderCellDef>CBU destino</th>
            <td mat-cell *matCellDef="let t">
              {{ cbuParcial(t.cbu) }}
              <span class="alias" *ngIf="t.alias">{{ t.alias }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="liquidaciones">
            <th mat-header-cell *matHeaderCellDef class="text-center">Liq.</th>
            <td mat-cell *matCellDef="let t" class="text-center">
              <span class="badge-cantidad">{{ t.cantidadLiquidaciones }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="importe">
            <th mat-header-cell *matHeaderCellDef class="text-right">Importe</th>
            <td mat-cell *matCellDef="let t" class="text-right importe-ok">
              {{ t.importe | currency }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnasTransferencias"></tr>
          <tr mat-row *matRowDef="let fila; columns: columnasTransferencias"></tr>
        </table>
      </div>

      <p class="sin-datos" *ngIf="dataSourceTransferencias.data.length === 0">
        <mat-icon>search_off</mat-icon>
        Ninguna transferencia puede exportarse.
      </p>

      <!-- Lo que NO va: la parte importante -->
      <h3 class="titulo-seccion" *ngIf="hayExcluidos()">
        <mat-icon>remove_circle_outline</mat-icon> Quedan afuera del archivo
      </h3>

      <div class="tabla-container" *ngIf="hayExcluidos()">
        <table mat-table [dataSource]="dataSourceExcluidos" class="tabla-dialog">

          <ng-container matColumnDef="propietario">
            <th mat-header-cell *matHeaderCellDef>Propietario</th>
            <td mat-cell *matCellDef="let e"><b>{{ e.propietario }}</b></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let e">
              <span class="motivo" [class.corregible]="e.esCorregible">
                <mat-icon>{{ e.esCorregible ? 'edit_note' : 'info_outline' }}</mat-icon>
                {{ e.motivo }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="liquidaciones">
            <th mat-header-cell *matHeaderCellDef class="text-center">Liq.</th>
            <td mat-cell *matCellDef="let e" class="text-center">
              <span class="badge-cantidad">{{ e.cantidadLiquidaciones }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="importe">
            <th mat-header-cell *matHeaderCellDef class="text-right">Importe</th>
            <td mat-cell *matCellDef="let e" class="text-right importe-fuera">
              {{ e.importe > 0 ? (e.importe | currency) : '—' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnasExcluidos"></tr>
          <tr mat-row *matRowDef="let fila; columns: columnasExcluidos"></tr>
        </table>
      </div>

      <p class="nota-corregibles" *ngIf="hayCorregibles()">
        <mat-icon>lightbulb</mat-icon>
        A los marcados con <mat-icon class="inline">edit_note</mat-icon> les falta cargar el CBU.
        Podés exportar igual y hacer un segundo archivo cuando los tengas.
      </p>

    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions class="acciones-dialog">
    <button mat-button color="warn" (click)="cerrar()">
      <mat-icon>cancel</mat-icon> Cancelar
    </button>

    <button mat-raised-button color="primary"
      [disabled]="cargando || !validacion.puedeExportar"
      (click)="confirmar()">
      <mat-icon>download</mat-icon>
      Generar y descargar
    </button>
  </mat-dialog-actions>

</div>
